import { requestType, SUPPLIER_ENDPOINTS } from "../../constants/Variables";
import Api from "../index";

const supplierSendCode = (params) => {
  return Api(SUPPLIER_ENDPOINTS.AUTHENTICATION.SEND_CODE, params, requestType.POST);
};

const registerSupplier = (params) => {
  return Api(SUPPLIER_ENDPOINTS.AUTHENTICATION.REGISTER, params, requestType.POST);
};

const loginSupplier = (params) => {
  return Api(SUPPLIER_ENDPOINTS.AUTHENTICATION.LOGIN, params, requestType.POST);
};

const supplierUpdateProfile = (id, params) => {
  return Api(
    SUPPLIER_ENDPOINTS.AUTHENTICATION.UPDATE_PROFILE.replace(":id", id),
    params,
    requestType.PUT
  );
};

const changePasswordSupplier = (params) => {
  return Api(SUPPLIER_ENDPOINTS.AUTHENTICATION.CHANGE_PASSWORD, params, requestType.POST);
};

const supplierUpdateSubscription = (id, params) => {
  return Api(
    SUPPLIER_ENDPOINTS.AUTHENTICATION.UPDATE_SUBSCRIPTION.replace(":id", id),
    params,
    requestType.PUT
  );
};

const supplierPurchaseSubscription = (params) => {
  return Api(SUPPLIER_ENDPOINTS.AUTHENTICATION.PURCHASE_SUBSCRIPTION, params, requestType.POST);
};

const getSupplierCurrentSubscription = (id) => {
  return Api(
    SUPPLIER_ENDPOINTS.AUTHENTICATION.GET_CURRENT_SUBSCRIPTION.replace(":id", id),
    null,
    requestType.GET
  );
};

export {
  supplierSendCode,
  registerSupplier,
  loginSupplier,
  supplierUpdateProfile,
  changePasswordSupplier,
  supplierUpdateSubscription,
  getSupplierCurrentSubscription,
  supplierPurchaseSubscription,
};
